<template>
    <b-popover
        v-if="keyResult.last_checkin"
        :target="`key-result-row-${keyResult.id}`"
        triggers="hover"
        placement="topright"
    >
        <template #title>
            <div class="text-bold text-center bb pb-sm mb-sm">{{ $t('checkIn.lastCheckIn') }}&nbsp;</div>
        </template>
        <div class="custom-popover-content">
            <div class="col-md-12">
                <label class="font-weight-bold">{{ $t('checkIn.currentValue') }}:</label>
                {{ keyResult.last_checkin.value }}
            </div>
            <div class="col-md-12">
                <label class="font-weight-bold">{{ $t('checkIn.targetValue') }}</label>
                {{ keyResult.last_checkin.key_result_target_value }}
            </div>
            <div class="col-md-12" v-show="keyResult.last_checkin.comments">
                <label class="font-weight-bold">{{ $t('checkIn.generalComments') }}</label>
                <div v-html="keyResult.last_checkin.comments" />
            </div>
            <div class="col-md-12" v-show="keyResult.last_checkin.difficulties">
                <label class="font-weight-bold">{{ $t('checkIn.difficultiesFound') }}</label>
                <div v-html="keyResult.last_checkin.difficulties" />
            </div>
            <div class="col-md-12">
                <div class="text-muted small" v-if="keyResult.last_checkin.created_at">
                    {{ $t('checkIn.performed_at') }}: {{ keyResult.last_checkin.created_at | formatDate }}
                </div>
            </div>
        </div>
    </b-popover>
</template>

<script>
import { getDateWithTime } from '@/lib/date'

export default {
    name: 'LastCheckInDetails',
    props: {
        keyResult: {
            type: Object,
            required: true,
        },
    },
    filters: {
        formatDate: function (value) {
            return getDateWithTime(value, 'DD/MM/YYYY HH:mm:ss')
        },
    },
}
</script>

<style scoped>
.custom-popover-content {
    max-height: 25rem;
    overflow-y: auto;
    padding: 10px;
}

::v-deep img {
    width: 100%;
}
</style>
